import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { CommonWordingModule } from '../common-wording';
import { icoCross, IconsModule } from '../icons';
import { LoadingIndicatorModule } from '../loading';
import { TooltipModule } from '../tooltip';
import { ButtonCloseModalComponent } from './button-close-modal/button-close-modal.component';
import { ButtonIconComponent } from './button-icon/button-icon.component';
import { ButtonWithEmbeddedTooltipComponent } from './button-with-embedded-tooltip/button-with-embedded-tooltip.component';
import { ButtonComponent } from './button/button.component';
import { ButtonsComponent } from './buttons/buttons.component';
import { ConfirmButtonsComponent } from './confirm-buttons/confirm-buttons.component';

@NgModule({
  declarations: [
    ButtonCloseModalComponent,
    ButtonIconComponent,
    ButtonComponent,
    ButtonWithEmbeddedTooltipComponent,
    ButtonsComponent,
    ConfirmButtonsComponent
  ],
  imports: [
    CommonModule,
    CommonWordingModule,
    LoadingIndicatorModule,
    IconsModule.withIcons(icoCross),
    MatomoTrackClickDirective,
    RouterModule,
    TooltipModule,
    TranslocoModule
  ],
  exports: [ButtonCloseModalComponent, ButtonComponent, ButtonIconComponent, ButtonWithEmbeddedTooltipComponent, ButtonsComponent, ConfirmButtonsComponent]
})
export class ButtonModule {}
